"use client";


import type { APIAppEnv } from "@rosette/ts/src/business/api/api_schema.js";
import { EnvProvider } from "@/components/env/EnvContext.js";
import Header from "@/components/layout/Header.js";
import Link from "next/link";
import BackArrow from "@rosette/web_components/src/icon/BackArrow.js";
import Footer from "@/components/layout/Footer.js";


interface NotFoundProps {
    appEnv: APIAppEnv;
}


export function NotFound({ appEnv }: NotFoundProps) {
    return (
        <EnvProvider appEnv={appEnv}>
            <main>
                <title>Not Found - RoyalUr.net</title>
                <Header />
                <section className="block text-center mb-24">
                    <h1 className="mb-6">Page Not Found</h1>
                    <p>I&apos;m afraid this page has been lost to history!</p>
                    <p>
                        <Link href="/">
                            <BackArrow />
                            Take me back to the homepage.
                        </Link>
                    </p>
                </section>
                <Footer />
            </main>
        </EnvProvider>
    );
}
